import { all } from "redux-saga/effects";

import recipessSaga from "./recipes/saga";

export default function* rootSaga() {
    yield all([recipessSaga()]);
}
